import { breakpoints, atQuery } from '../components/mediaQueries';
import { gsap } from 'gsap';
import { open as collapseOpen } from '../components/gsap-collapse';
import { throttle } from '../helpers';
import Cookies from 'js-cookie';
import ResizeSensor from "resize-sensor";

window.ResizeSensor = ResizeSensor;

import 'sticky-sidebar/dist/jquery.sticky-sidebar.js';

(function(window, $) {

    /////////// PILLS NAV
    const $pillsContainer = $('.pills-list__wrapper');
    const $pillsList = $pillsContainer.find('.pills-list');
    const $pill = $pillsContainer.find('.pill');

    const hidePills = function() {
        const pillsHeight = $pill.outerHeight(true);

        $pillsList.height(pillsHeight + 20);
        $pillsContainer.height(pillsHeight);

        $pillsContainer.width() <= $pillsList.width() ? $pillsContainer.addClass('pills-list__wrapper--overflowing') : $pillsContainer.removeClass('pills-list__wrapper--overflowing');
    };

    $(window).on('resize', throttle(hidePills, 300));
    hidePills();
    /////////// PILLS NAV

    /////////// FILTERS
    const $filtersContainer = $('[data-filters-container]');
    const $filtersContainerInner = $filtersContainer.find(' > div');
    const $filterGroups = $filtersContainer.find('.tags-filters');
    const $filtersToggle = $('[data-filters-toggle]');
    const $filtersClose = $filtersContainer.find('.close-drawer');
    const $filtersDrawer = $('.filters-drawer');

    if($filtersContainer.length && $filtersToggle.length) {
        const toggleFilterToggler = function() {
            if(window.innerWidth >= breakpoints.lg) {
                $('[data-toggle-label].show').toggle();
                $('[data-toggle-label].hide').toggle();
            }
        };

        const tl = gsap.timeline({paused: true, reversed: true});
        //tl.to($filtersDrawer, {duration: .35, autoAlpha: 0, ease: "power3.inOut" })
        //.to($filtersDrawer, { duration: .55, width: 0, flex: "0 0 0%", ease: "power3.inOut"}, 0.15);

        gsap.set($filtersContainerInner, { y: '50px', opacity: 0});

        atQuery('min', 'lg', function(){
            $filtersToggle.off('click');

            $filtersToggle.on('click', function(){
                    if(tl.reversed()){
                        Cookies.set('DAGENCY_FILTERS_OPEN', 'false');
                        tl.timeScale(1).play();
                    } else {
                        Cookies.set('DAGENCY_FILTERS_OPEN', 'true');
                        tl.timeScale(1).reverse();
                    };
                }
            );

            // Transition from drawer to container
            gsap.set($filtersDrawer, { y: 0, autoAlpha: 1, flex: "0 0 25%"});

            if(Cookies.get('DAGENCY_FILTERS_OPEN') === 'true') {
                tl.timeScale(100).reverse(0); // Open without animating
            } else {
                tl.timeScale(100).play(0); // Close without animating
            }
        });


        // ONLOAD
        if(Cookies.get('DAGENCY_FILTERS_OPEN') === 'true') {
            if(window.innerWidth >= breakpoints.lg) {
                tl.timeScale(100).reverse(0); // Open without animating
                $('[data-toggle-label].show').hide();
                $('[data-toggle-label].hide').show();
            }

        } else {
            toggleFilterToggler();
            if(window.innerWidth >= breakpoints.lg) {
                tl.timeScale(100).play(0); // Close without animating
                $('[data-toggle-label].show').show();
                $('[data-toggle-label].hide').hide();
            }
        }

        // Show filters with animation
        gsap.to($filtersContainerInner, {  y: 0, opacity: 1, duration: .5, delay: .5 });


        atQuery('max', 'lg', function(){
            $filtersToggle.off('click');
            $filtersToggle.on('click', function(){
                $('html').addClass('js-drawer-open js-drawer-open-filters');
                $('body').css('overflow', 'hidden');
                gsap.to($filtersDrawer, { duration: .55, y: 0, autoAlpha: 1, ease: "power3.inOut"})
            })

            $filtersClose.on('click', function(){
                $('html').removeClass('js-drawer-open js-drawer-open-filters');
                $('body').css('overflow', 'auto');
                gsap.to($filtersDrawer, { duration: .55, y: '-100%', autoAlpha: 0, ease: "power3.inOut"})
            });

            // Resize to show drawer + close drawer
            gsap.set($filtersDrawer, { width: '100%', flex: "0 0 0%", y: '-100%', autoAlpha: 0, });
        });
    }

    // Open on load in desktop BP
    if(window.innerWidth >= breakpoints.lg) {
        $filterGroups.each(function() {
            collapseOpen(this, true);
            $(this).attr('data-collapse-status', 'open');
        });

        document.querySelector('.active-facets-desktop').innerHTML.trim().length ? $('.active-facets__button-remove').show() : $('.active-facets__button-remove').hide();

    }
    /////////// FILTERS


    /////// TEXT TOGGLER
    if(window.innerWidth >= breakpoints.lg){
        $(document).on('click', '[data-toggle-trigger]', function(){
            $(this).find('[data-toggle-label]').toggle();
        });

        $(document).on('click', '.close-drawer', function(){
            $('[data-toggle-label].show').toggle();
            $('[data-toggle-label].hide').toggle();
        })
    }
    /////// TEXT TOGGLER

    //sticky filters
    // const sticky_sidebar = new StickySidebar(document.querySelector('#main-collection-filters'),{
    //     containerSelector: '.filters-drawer',
    //     innerWrapperSelector: '.facets-container',
    //     topSpacing: 150,
    //     bottomSpacing: 5,
    //     resizeSensor: true,
    //     stickyClass: 'is-affixed'
    // });


    $(document).on('click', 'filter-container input', () => $('#FacetFiltersForm').submit());


})(window, jQuery);


if(window.innerWidth < breakpoints.lg) {
    var lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    window.addEventListener("scroll", function(){
        var st = window.pageYOffset || document.documentElement.scrollTop;
        var filters = document.querySelector('.filters-wrapper > .plp-control-toggles');
        var filters_height = filters.offsetHeight;
        const active_filters = document.querySelector('.active-facets-mobile');

        document.body.style.setProperty('--filters-height', filters_height + 'px');

        if (st > lastScrollTop){
            if(document.documentElement.scrollTop > 200){
                filters.classList.add('scrolled');
                active_filters.classList.add('scrolled');
            }
        }
        else {
            if(document.documentElement.scrollTop > 200){
                filters.classList.add('scrolled');
                active_filters.classList.add('scrolled');
            } else {
                filters.classList.remove('scrolled');
                active_filters.classList.remove('scrolled');
            }
        }

        if(document.documentElement.scrollTop < 200 ){
            filters.classList.remove('scrolled');
            active_filters.classList.remove('scrolled');
        }

        lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    }, false);

    document.addEventListener("DOMContentLoaded", function() {

        const filters = document.querySelector('.filters-wrapper > .plp-control-toggles');
        const active_filters = document.querySelector('.active-facets-mobile');
        if(window.innerWidth < breakpoints.lg && window.pageYOffset > 200){
            filters.classList.add('scrolled');
        }
    });
}

